module.exports = {"content":{},"productInfo":{"code":"{9B9537F0-4288-4986-BAF2-FEAFADB0EDC6}","name":"日本語　初中級","serialHead":"NTNVS","courseResourceIDs":[{"levelNo":1,"resourceID":"0c8a93270ddf712893a1bb6e6ec8ba345c08ec53"},{"levelNo":2,"resourceID":"9679fd19bb1cc8369777f2d1d071d4606162d6ad"},{"levelNo":3,"resourceID":"55d44b03d9d521b4b00e077e6bd2d167cecf9982"}],"language":"ja-JP","challengeCount":22364},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1